enum Envs {
  DEV = 'dev',
  DEMO = 'demo',
  STAGE = 'stage',
  PROD = 'prod',
}

export default Envs;
